/**
 * Zap 1.0 Web Entry Point
 * 
 * This is the main JavaScript entry point for the application.
 */

// Importing CSS
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/main.scss';

// Importing components
import initVideoPlayer from './js/components/videoPlayer';
import initParticles from './js/components/particles';
// import initHalloweenMode from './js/components/halloween';
import { initDarkMode } from './js/components/darkMode';
import initImageToggle from './js/components/img-toggle';
import initLinkLine from './js/components/links';

// Initialize the application
const app = () => {
    console.log(`
                             
██████ ▄████▄ █████▄ 
 ▄▄▀▀  ██▄▄██ ██▄▄█▀ 
██████ ██  ██ ██     
`);
    console.log("%cv2.0.2", "background-color: #333333; color: #FFFFFF; padding: 8px;");

    // Systems Initialization
    initLinkLine();
    initImageToggle();
    initDarkMode();
    // initHalloweenMode();
    initImageToggle();
    initVideoPlayer();
    initParticles();
};

                     


// Run the application after the document has been parsed
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', app, { once: true });
} else {
    app();
}